import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { recordPageView } from '../api/pageViewLog';

// Per-route navigation tracker. Mounted once in AppShell (so it only runs for
// authenticated users — AppShell sits inside <ProtectedRoute />, and unauth
// users never get here). Listens to useLocation().pathname so query / hash
// changes don't count as separate views; debounces 500ms so rapid bouncing
// between screens collapses to a single recorded view per resting page.
//
// Best-effort: errors are swallowed (analytics must NEVER disturb the user
// or block navigation). The backend silently no-ops unknown URLs by
// returning 204, so untracked paths cost one HTTP round-trip and nothing
// more.
export function usePageViewTracker() {
  const { pathname } = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return; // belt-and-braces (AppShell is auth-gated anyway)

    const handle = window.setTimeout(() => {
      recordPageView(pathname).catch(() => {
        // page-view tracking is best-effort; never disturb the user
      });
    }, 500);

    return () => window.clearTimeout(handle);
  }, [pathname, user]);
}
